/* ============================================
   SOLUTIONS BUREAUPAK — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile Menu Toggle ----
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');

  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('active');
      const icon = this.querySelector('i');
      if (mobileNav.classList.contains('active')) {
        icon.className = 'fa-solid fa-xmark';
      } else {
        icon.className = 'fa-solid fa-bars';
      }
    });
  }

  // ---- Mobile Subnav Toggles ----
  document.querySelectorAll('.mobile-nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const subnav = this.nextElementSibling;
      if (subnav) {
        subnav.classList.toggle('active');
        const caret = this.querySelector('.fa-caret-down');
        if (caret) {
          caret.style.transform = subnav.classList.contains('active') ? 'rotate(180deg)' : '';
        }
      }
    });
  });

  // ---- Product Image Gallery ----
  const mainImage = document.querySelector('.product-main-image img');
  const mainImageWrap = document.querySelector('.product-main-image');
  const thumbnails = document.querySelectorAll('.product-thumbnail');

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbnails.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImage) {
        var thumbImg = this.querySelector('img');
        var fullSrc = thumbImg && (thumbImg.dataset.fullSrc || thumbImg.getAttribute('data-full-src'));
        mainImage.src = fullSrc || (thumbImg ? thumbImg.src : mainImage.src);
      }
    });
  });

  // ---- PDP Image Zoom Lightbox (magnifying glass on click) ----
  if (mainImageWrap) {
    var zoomOverlay = null;

    function openZoom(srcUrl) {
      if (zoomOverlay) closeZoom();
      zoomOverlay = document.createElement('div');
      zoomOverlay.className = 'pdp-zoom-overlay';
      zoomOverlay.setAttribute('data-testid', 'pdp-zoom-overlay');
      zoomOverlay.innerHTML =
        '<button type="button" class="pdp-zoom-close" aria-label="Close zoom" data-testid="pdp-zoom-close">' +
          '<i class="fa-solid fa-xmark"></i>' +
        '</button>' +
        '<div class="pdp-zoom-stage" data-zoom-stage>' +
          '<img alt="Zoomed product image" src="' + srcUrl + '">' +
        '</div>' +
        '<span class="pdp-zoom-hint">Hover to magnify · Click to toggle</span>';
      document.body.appendChild(zoomOverlay);
      document.body.style.overflow = 'hidden';
      // Force reflow then add open class for fade-in
      void zoomOverlay.offsetWidth;
      zoomOverlay.classList.add('is-open');

      var stage = zoomOverlay.querySelector('[data-zoom-stage]');
      stage.style.setProperty('--zoom-bg', 'url("' + srcUrl + '")');

      var zoomEnabled = false;

      stage.addEventListener('click', function () {
        zoomEnabled = !zoomEnabled;
        stage.classList.toggle('is-zooming', zoomEnabled);
      });

      stage.addEventListener('mousemove', function (ev) {
        if (!zoomEnabled) return;
        var rect = stage.getBoundingClientRect();
        var x = ((ev.clientX - rect.left) / rect.width) * 100;
        var y = ((ev.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        stage.style.setProperty('--zoom-pos', x + '% ' + y + '%');
        stage.style.setProperty('--zoom-size', '220%');
      });

      stage.addEventListener('mouseleave', function () {
        if (zoomEnabled) {
          zoomEnabled = false;
          stage.classList.remove('is-zooming');
        }
      });

      zoomOverlay.addEventListener('click', function (ev) {
        if (ev.target === zoomOverlay) closeZoom();
      });
      zoomOverlay.querySelector('.pdp-zoom-close').addEventListener('click', closeZoom);

      document.addEventListener('keydown', escClose);
    }

    function escClose(ev) { if (ev.key === 'Escape') closeZoom(); }
    function closeZoom() {
      if (!zoomOverlay) return;
      zoomOverlay.classList.remove('is-open');
      document.removeEventListener('keydown', escClose);
      var node = zoomOverlay;
      zoomOverlay = null;
      setTimeout(function () { if (node && node.parentNode) node.parentNode.removeChild(node); }, 200);
      document.body.style.overflow = '';
    }

    mainImageWrap.addEventListener('click', function () {
      if (!mainImage || !mainImage.src) return;
      openZoom(mainImage.src);
    });
  }

  // ---- Product Tabs ----
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabGroup = this.closest('.product-tabs');
      tabGroup.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      tabGroup.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
      this.classList.add('active');
      var panel = tabGroup.querySelector('#' + this.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });

  // ---- Quantity Selectors ----
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    var input = selector.querySelector('input');
    var minus = selector.querySelector('.qty-minus');
    var plus = selector.querySelector('.qty-plus');

    if (minus && input) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    }

    if (plus && input) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  // ---- Variant Selectors ----
  document.querySelectorAll('.variant-option').forEach(function (option) {
    option.addEventListener('click', function () {
      var group = this.closest('.variant-options');
      group.querySelectorAll('.variant-option').forEach(function (o) { o.classList.remove('selected'); });
      this.classList.add('selected');

      // Update hidden select
      var variantId = this.dataset.variantId;
      var select = document.querySelector('select[name="id"]');
      if (select && variantId) {
        select.value = variantId;
      }
    });
  });

  // ---- User dropdown (close on click outside) ----
  document.addEventListener('click', function (e) {
    var dropdown = document.querySelector('.user-dropdown');
    var trigger = document.querySelector('.user-dropdown-trigger');
    if (dropdown && trigger && !trigger.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.style.display = 'none';
    }
  });

  var userTrigger = document.querySelector('.user-dropdown-trigger');
  var userDropdown = document.querySelector('.user-dropdown');
  if (userTrigger && userDropdown) {
    userTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      userDropdown.style.display = userDropdown.style.display === 'block' ? 'none' : 'block';
    });
  }

  // ---- Announcement Bar (auto-dismiss after scroll + sessionStorage persistence) ----
  (function () {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var STORAGE_KEY = 'sb_announcement_dismissed';

    function dismiss(persist) {
      bar.classList.add('is-dismissed');
      if (persist) {
        try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      }
    }

    // Respect prior dismissal in this session
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') {
        bar.classList.add('is-dismissed');
        return;
      }
    } catch (e) {}

    // Close button
    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dismiss(true); });

    // Auto-dismiss after scroll (default 7s)
    var seconds = parseInt(bar.getAttribute('data-auto-dismiss-seconds') || '', 10);
    if (isNaN(seconds)) seconds = 7;
    if (seconds > 0) {
      var scrollStarted = false;
      function onScroll() {
        if (scrollStarted || window.scrollY < 4) return;
        scrollStarted = true;
        window.removeEventListener('scroll', onScroll);
        setTimeout(function () { dismiss(false); }, seconds * 1000);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  })();

  // ---- AJAX Add-to-Cart + Mini Cart Drawer ----
  // Intercepts /cart/add forms, opens a slide-in drawer with full cart contents,
  // updates the header cart badge, and refreshes the cart page if we're on it.
  (function () {
    // ---- Drawer strings, EN/FR by <html lang> (2026-10-03: the drawer was English-only on the French storefront) ----
    var __fr = ((document.documentElement.getAttribute('lang') || 'en').toLowerCase().indexOf('fr') === 0);
    var T = __fr ? {
      aria: 'Mini-panier', title: 'Votre panier', close: 'Fermer le panier', subtotal: 'Sous-total',
      note: 'Taxes et livraison calcul\u00e9es \u00e0 la caisse', view: 'Voir le panier', checkout: 'Passer \u00e0 la caisse',
      emptyTitle: 'Votre panier est vide', emptyText: 'Ajoutez un article pour commencer.',
      dec: 'R\u00e9duire la quantit\u00e9', inc: 'Augmenter la quantit\u00e9', remove: "Retirer l'article",
      errTitle: "Impossible d'ajouter au panier", errText: 'Veuillez r\u00e9essayer.'
    } : {
      aria: 'Mini cart', title: 'Your cart', close: 'Close cart', subtotal: 'Subtotal',
      note: 'Taxes and shipping calculated at checkout', view: 'View cart', checkout: 'Checkout',
      emptyTitle: 'Your cart is empty', emptyText: 'Add something you like to get started.',
      dec: 'Decrease quantity', inc: 'Increase quantity', remove: 'Remove item',
      errTitle: "Couldn't add to cart", errText: 'Please try again.'
    };
    // Locale-aware links: Shopify.routes.root is '/' on EN and '/fr/' on FR.
    var __root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    T.cartUrl = __root + 'cart'; T.checkoutUrl = __root + 'checkout';
    // ---- Build drawer + backdrop ----
    var backdrop = document.createElement('div');
    backdrop.className = 'mini-cart-backdrop';
    document.body.appendChild(backdrop);

    var drawer = document.createElement('aside');
    drawer.className = 'mini-cart';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', T.aria);
    drawer.innerHTML =
      '<div class="mini-cart-header">' +
        '<h2><i class="fa-solid fa-cart-shopping"></i> ' + escapeHtml(T.title) + ' <span class="mini-cart-count" data-mini-count>0</span></h2>' +
        '<button type="button" class="mini-cart-close" aria-label="' + escapeHtml(T.close) + '"><i class="fa-solid fa-xmark"></i></button>' +
      '</div>' +
      '<div class="mini-cart-body" data-mini-body></div>' +
      '<div class="mini-cart-footer" data-mini-footer hidden>' +
        '<div class="mini-cart-subtotal">' +
          '<span class="label">' + escapeHtml(T.subtotal) + '</span>' +
          '<span class="value" data-mini-subtotal>$0.00</span>' +
        '</div>' +
        '<p class="mini-cart-shipping-note">' + escapeHtml(T.note) + '</p>' +
        '<div class="mini-cart-actions">' +
          '<a href="' + escapeHtml(T.cartUrl) + '" class="btn btn-outline btn-lg">' + escapeHtml(T.view) + '</a>' +
          '<a href="' + escapeHtml(T.checkoutUrl) + '" class="btn btn-primary btn-lg">' + escapeHtml(T.checkout) + ' <i class="fa-solid fa-arrow-right"></i></a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(drawer);

    // ---- Lightweight toast (only used for errors now) ----
    var toastContainer = document.createElement('div');
    toastContainer.className = 'atc-toast-container';
    document.body.appendChild(toastContainer);

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function showErrorToast(msg) {
      var toast = document.createElement('div');
      toast.className = 'atc-toast atc-toast--error';
      toast.innerHTML =
        '<div class="atc-toast-icon"><i class="fa-solid fa-triangle-exclamation"></i></div>' +
        '<div class="atc-toast-body">' +
          '<div class="atc-toast-title">' + escapeHtml(T.errTitle) + '</div>' +
          '<div class="atc-toast-text">' + escapeHtml(msg || T.errText) + '</div>' +
        '</div>';
      toastContainer.appendChild(toast);
      requestAnimationFrame(function () { toast.classList.add('atc-toast--show'); });
      setTimeout(function () {
        toast.classList.remove('atc-toast--show');
        setTimeout(function () { toast.remove(); }, 400);
      }, 3500);
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function openDrawer() {
      backdrop.classList.add('is-open');
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      backdrop.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    backdrop.addEventListener('click', closeDrawer);
    drawer.querySelector('.mini-cart-close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    function updateCartBadge(count) {
      var cartLinks = document.querySelectorAll('.header-action-link .cart-icon-wrap');
      cartLinks.forEach(function (wrap) {
        var badge = wrap.querySelector('.cart-badge') || wrap.querySelector('.badge');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cart-badge';
            wrap.appendChild(badge);
          }
          badge.textContent = count;
          badge.setAttribute('aria-label', count + ' items in cart');
          badge.classList.remove('is-pulsing');
          void badge.offsetWidth;
          badge.classList.add('is-pulsing');
        } else if (badge) {
          badge.remove();
        }
      });
    }

    function renderDrawer(cart, justAddedKey) {
      var body = drawer.querySelector('[data-mini-body]');
      var footer = drawer.querySelector('[data-mini-footer]');
      drawer.querySelector('[data-mini-count]').textContent = cart.item_count || 0;

      if (!cart.items || cart.items.length === 0) {
        body.innerHTML =
          '<div class="mini-cart-empty">' +
            '<i class="fa-solid fa-cart-shopping"></i>' +
            '<h3 style="font-size:1.125rem;color:var(--color-text);margin-bottom:0.25rem;">' + escapeHtml(T.emptyTitle) + '</h3>' +
            '<p>' + escapeHtml(T.emptyText) + '</p>' +
          '</div>';
        footer.hidden = true;
        return;
      }

      var html = cart.items.map(function (item) {
        var imageUrl = item.image || item.featured_image && item.featured_image.url;
        if (imageUrl && imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var key = String(item.key || '');
        var highlight = (justAddedKey && key === justAddedKey) ? ' is-just-added' : '';
        return (
          '<div class="mini-cart-item' + highlight + '" data-line-key="' + escapeHtml(key) + '">' +
            '<a href="' + escapeHtml(item.url) + '" class="mini-cart-item-image">' +
              (imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title || item.title) + '">' : '') +
            '</a>' +
            '<div class="mini-cart-item-info">' +
              '<a href="' + escapeHtml(item.url) + '" class="mini-cart-item-title">' + escapeHtml(item.product_title || item.title) + '</a>' +
              (variantLabel ? '<div class="mini-cart-item-variant">' + escapeHtml(variantLabel) + '</div>' : '') +
              '<div class="mini-cart-item-qty">' +
                '<button type="button" data-qty-minus aria-label="' + escapeHtml(T.dec) + '"><i class="fa-solid fa-minus" style="font-size:.65rem;"></i></button>' +
                '<input type="number" value="' + item.quantity + '" min="0" readonly>' +
                '<button type="button" data-qty-plus aria-label="' + escapeHtml(T.inc) + '"><i class="fa-solid fa-plus" style="font-size:.65rem;"></i></button>' +
              '</div>' +
            '</div>' +
            '<div class="mini-cart-item-end">' +
              '<button type="button" class="mini-cart-item-remove" data-remove aria-label="' + escapeHtml(T.remove) + '"><i class="fa-regular fa-trash-can"></i></button>' +
              '<div class="mini-cart-item-price">' + formatMoney(item.final_line_price || item.line_price || (item.price * item.quantity)) + '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      body.innerHTML = html;
      footer.hidden = false;
      drawer.querySelector('[data-mini-subtotal]').textContent = formatMoney(cart.total_price || 0);

      // Bind qty + remove
      body.querySelectorAll('.mini-cart-item').forEach(function (row) {
        var key = row.getAttribute('data-line-key');
        var input = row.querySelector('input');
        row.querySelector('[data-qty-minus]').addEventListener('click', function () {
          changeLine(key, Math.max(0, (parseInt(input.value) || 1) - 1));
        });
        row.querySelector('[data-qty-plus]').addEventListener('click', function () {
          changeLine(key, (parseInt(input.value) || 1) + 1);
        });
        row.querySelector('[data-remove]').addEventListener('click', function () {
          changeLine(key, 0);
        });
      });

      // Asynchronously check stock availability per item and flag sold-out lines
      checkMiniCartAvailability(cart, body);
    }

    var miniCartAvailCache = {};
    function checkMiniCartAvailability(cart, body) {
      if (!cart.items || !body) return;
      // Group lines by product handle
      var handles = {};
      cart.items.forEach(function (item) {
        var handle = item.handle || (item.url ? String(item.url).split('?')[0].split('/products/')[1] : null);
        if (!handle) return;
        handle = handle.split('/')[0];
        if (!handles[handle]) handles[handle] = [];
        handles[handle].push(item);
      });

      Object.keys(handles).forEach(function (handle) {
        var lines = handles[handle];
        var processProduct = function (productData) {
          if (!productData || !productData.variants) return;
          var byId = {};
          productData.variants.forEach(function (v) { byId[v.id] = v; });
          lines.forEach(function (item) {
            var variant = byId[item.variant_id] || byId[item.id];
            var unavailable = variant ? !variant.available : !productData.available;
            if (!unavailable) return;
            var row = body.querySelector('[data-line-key="' + cssEscape(item.key) + '"]');
            if (!row || row.classList.contains('mini-cart-item--sold-out')) return;
            row.classList.add('mini-cart-item--sold-out');
            var imageWrap = row.querySelector('.mini-cart-item-image');
            if (imageWrap && !imageWrap.querySelector('.mini-cart-item-soldout-badge')) {
              var badge = document.createElement('span');
              badge.className = 'cart-item-soldout-badge';
              badge.textContent = 'Sold out';
              imageWrap.appendChild(badge);
            }
            var info = row.querySelector('.mini-cart-item-info');
            if (info && !info.querySelector('.mini-cart-item-soldout-badge')) {
              var note = document.createElement('span');
              note.className = 'mini-cart-item-soldout-badge';
              note.textContent = 'Sold out';
              info.appendChild(note);
            }
          });
        };

        if (miniCartAvailCache[handle]) {
          processProduct(miniCartAvailCache[handle]);
          return;
        }
        fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data) return;
            miniCartAvailCache[handle] = data;
            processProduct(data);
          })
          .catch(function () { /* swallow */ });
      });
    }

    function cssEscape(s) {
      return String(s).replace(/(["\\])/g, '\\$1');
    }

    function fetchCart() {
      return fetch(__root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    function changeLine(key, quantity) {
      var fd = new FormData();
      fd.append('id', key);
      fd.append('quantity', quantity);
      return fetch(__root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartBadge(cart.item_count);
          renderDrawer(cart);
          refreshCartPage();
        });
    }

    function refreshCartPage() {
      var cartItems = document.querySelector('[data-cart-items]');
      if (!cartItems) return;
      fetch(window.location.pathname, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCart = doc.querySelector('.cart-page .container');
          var currentCart = document.querySelector('.cart-page .container');
          if (newCart && currentCart) {
            currentCart.innerHTML = newCart.innerHTML;
            bindCartAddForms(document);
            bindRecoScrollers(document);
          }
        }).catch(function () { /* no-op */ });
    }

    function handleAddToCart(form, button) {
      var formData = new FormData(form);
      if (button) button.classList.add('is-loading');
      var addedKey = null;

      fetch(__root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
        credentials: 'same-origin'
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            showErrorToast((result.data && result.data.description) || T.errText);
            return;
          }
          addedKey = (result.data && result.data.key) ? String(result.data.key) : null;
          return fetchCart().then(function (cart) {
            updateCartBadge(cart.item_count);
            renderDrawer(cart, addedKey);
            openDrawer();
            refreshCartPage();
          });
        })
        .catch(function () {
          showErrorToast(__fr ? 'V\u00e9rifiez votre connexion.' : 'Please check your connection.');
        })
        .finally(function () {
          if (button) button.classList.remove('is-loading');
        });
    }

    function bindCartAddForms(root) {
      // 2026-10-03: also match locale-prefixed actions (/fr/cart/add) — on the French storefront the forms
      // were never intercepted, so add-to-cart left the page and landed on the English /cart.
      var forms = (root || document).querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"], form[action$="/cart/add"]');
      forms.forEach(function (form) {
        if (form.dataset.ajaxBound === '1') return;
        form.dataset.ajaxBound = '1';

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var btn = form.querySelector('button[type="submit"], [type="submit"]');
          handleAddToCart(form, btn);
        });

        var submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
        if (submitBtn) {
          submitBtn.addEventListener('click', function (e) { e.stopPropagation(); });
        }
      });
    }

    // Also make the header Cart link open the drawer (optional quick access)
    document.querySelectorAll('.header-action-link[href="/cart"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        // Keep link as a fallback for middle-click / cmd-click etc.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        fetchCart().then(function (cart) { renderDrawer(cart); openDrawer(); });
      });
    });

    bindCartAddForms(document);

    // 2026-10-03: delegated fallback. Collection grids render their product cards after DOMContentLoaded
    // (cards-only view), so the forms above were never bound and a quick-add left the page for /cart.
    // Capture-phase submit on the document catches every /cart/add form, present now or rendered later.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM' || form.dataset.ajaxBound === '1') return;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add$/.test(action)) return;
      e.preventDefault();
      e.stopPropagation();
      handleAddToCart(form, form.querySelector('button[type="submit"], [type="submit"]'));
    }, true);

    // Expose bindRecoScrollers hook
    window.__reboundRecoScrollers = function () { bindRecoScrollers(document); };
  })();

  // ---- Generic horizontal scroller bindings ----
  function bindRecoScrollers(root) {
    (root || document).querySelectorAll('[data-reco-scroller], [data-recently-viewed]').forEach(function (scroller) {
      if (scroller.dataset.recoBound === '1') return;
      scroller.dataset.recoBound = '1';
      var track = scroller.querySelector('[data-reco-track]') || scroller.querySelector('[data-recently-viewed-track]');
      var prev = scroller.querySelector('.reco-scroll-btn--prev');
      var next = scroller.querySelector('.reco-scroll-btn--next');
      if (!track || !prev || !next) return;

      function scrollAmount() {
        var firstCard = track.querySelector('.cart-reco-card');
        if (!firstCard) return track.clientWidth;
        var w = firstCard.getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
        var visible = Math.max(1, Math.round(track.clientWidth / (w + gap)));
        return visible * (w + gap);
      }
      function hasOverflow() { return track.scrollWidth > track.clientWidth + 1; }
      function update() {
        var o = hasOverflow();
        prev.disabled = !o;
        next.disabled = !o;
      }
      prev.addEventListener('click', function () {
        if (!hasOverflow()) return;
        if (track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        if (!hasOverflow()) return;
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
      window.addEventListener('resize', update);
      update();
    });
  }
  bindRecoScrollers(document);

  // ---- Recently Viewed tracking + rendering ----
  (function () {
    var STORAGE_KEY = 'sb_recently_viewed';
    var MAX_ITEMS = 12;

    function readStore() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') || []; }
      catch (e) { return []; }
    }
    function writeStore(arr) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
    }

    // If we're on a product page, add the current product to the store (at the front).
    var currentEl = document.querySelector('script[data-current-product]');
    var currentProduct = null;
    if (currentEl) {
      try { currentProduct = JSON.parse(currentEl.textContent); } catch (e) {}
    }
    if (currentProduct && currentProduct.handle) {
      var list = readStore().filter(function (p) { return p && p.handle && p.handle !== currentProduct.handle; });
      list.unshift(currentProduct);
      if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
      writeStore(list);
    }

    // Render recently viewed — skip the CURRENT product on PDP
    var section = document.querySelector('[data-recently-viewed]');
    var track = section && section.querySelector('[data-recently-viewed-track]');
    if (!section || !track) return;

    var saved = readStore();
    var currentHandle = currentProduct && currentProduct.handle;
    var filtered = saved.filter(function (p) { return p && p.handle && p.handle !== currentHandle; });
    if (filtered.length === 0) return; // keep hidden

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    track.innerHTML = filtered.map(function (p) {
      var priceHtml = p.on_sale
        ? '<span class="product-card-price">' + escapeHtml(p.price) + '</span>' +
          (p.compare_at_price ? '<span class="product-card-compare-price">' + escapeHtml(p.compare_at_price) + '</span>' : '')
        : '<span class="product-card-price">' + escapeHtml(p.price || '') + '</span>';
      var img = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
        : '<div style="width:100%;height:100%;background:var(--color-bg-secondary);display:flex;align-items:center;justify-content:center;color:#ccc;"><i class="fa-regular fa-image" style="font-size:2rem;"></i></div>';
      return (
        '<div class="cart-reco-card">' +
          '<a href="' + escapeHtml(p.url) + '" class="product-card">' +
            '<div class="product-card-image">' + img +
              (p.on_sale ? '<span class="product-card-badge">SALE</span>' : '') +
            '</div>' +
            '<div class="product-card-body">' +
              '<h3 class="product-card-title">' + escapeHtml(p.title || '') + '</h3>' +
              '<div class="product-card-prices">' + priceHtml + '</div>' +
            '</div>' +
          '</a>' +
        '</div>'
      );
    }).join('');

    section.hidden = false;
    // Bind arrows to the newly-visible scroller
    bindRecoScrollers(section.parentElement || document);
  })();

  // ---- Category Scroller (arrow buttons + looping) ----
  document.querySelectorAll('[data-category-scroller]').forEach(function (scroller) {
    var track = scroller.querySelector('[data-category-track]');
    var prevBtn = scroller.querySelector('.category-scroll-btn--prev');
    var nextBtn = scroller.querySelector('.category-scroll-btn--next');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      var firstCard = track.querySelector('.category-card');
      if (!firstCard) return track.clientWidth;
      var cardWidth = firstCard.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      var visible = Math.max(1, Math.round(track.clientWidth / (cardWidth + gap)));
      return visible * (cardWidth + gap);
    }

    function hasOverflow() {
      return track.scrollWidth > track.clientWidth + 1;
    }

    function updateButtons() {
      // With looping, arrows are always enabled as long as there is overflow
      var overflow = hasOverflow();
      prevBtn.disabled = !overflow;
      nextBtn.disabled = !overflow;
    }

    prevBtn.addEventListener('click', function () {
      if (!hasOverflow()) return;
      var amount = scrollAmount();
      // If we're at (or near) the start, loop to the end
      if (track.scrollLeft <= 2) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -amount, behavior: 'smooth' });
      }
    });

    nextBtn.addEventListener('click', function () {
      if (!hasOverflow()) return;
      var amount = scrollAmount();
      var maxScroll = track.scrollWidth - track.clientWidth;
      // If we're at (or near) the end, loop back to the start
      if (track.scrollLeft >= maxScroll - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: amount, behavior: 'smooth' });
      }
    });

    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

}); // end of first DOMContentLoaded handler

/* ============================================
   COLLECTION FILTERS + PDP FILTER DRAWER
   ============================================ */
document.addEventListener('DOMContentLoaded', function () {

  // ---- Filter group accordions (shared) ----
  document.querySelectorAll('[data-cf-group]').forEach(function (group) {
    var toggle = group.querySelector('.cf-group-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var isOpen = group.hasAttribute('open');
      if (isOpen) {
        group.removeAttribute('open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        group.setAttribute('open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ---- Spec-based filter checkboxes (client-side, description-driven) ----
  // Spec checkboxes carry data-spec-key + data-spec-value. We:
  //   • read all checked specs on submit / on change
  //   • persist them to the URL as ?spec.brand=Samsung,Apple&spec.ram=6+GB
  //   • on every page load, hide product cards whose data-spec-* attributes
  //     don't match all active filter groups (a card must match at least one
  //     value within each active group — AND across groups, OR within a group).
  //   • the form still submits natively so native filter.v.* / sort_by /
  //     availability / price params travel to the server as usual.
  function readSpecFiltersFromUrl() {
    var out = {};
    try {
      var qs = new URLSearchParams(window.location.search);
      qs.forEach(function (val, key) {
        if (key.indexOf('spec.') === 0 && val) {
          var k = key.slice(5); // strip "spec."
          out[k] = val.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
        }
      });
    } catch (e) {}
    return out;
  }

  var CLIENT_PER_PAGE = 50;
  var currentClientPage = 1;

  function applySpecFiltersToCards(filters) {
    var cards = document.querySelectorAll('[data-product-card-wrap]');
    if (!cards.length) return { total: 0, visible: 0 };
    var keys = Object.keys(filters);
    var visibleCount = 0;
    var onSaleOnly = false;
    var inStockOnly = false;
    var outOfStockOnly = false;
    var dMin = 0, dMax = 100, hasDiscountRange = false;
    try {
      var qsCheck = new URLSearchParams(window.location.search);
      if (qsCheck.get('on_sale') === '1') onSaleOnly = true;
      // Client-side availability filter (works even without Search & Discovery)
      var avail = qsCheck.get('filter.v.availability');
      if (avail === '1') inStockOnly = true;
      if (avail === '0') outOfStockOnly = true;
      // Discount % range (Specials page slider)
      var rawMin = qsCheck.get('min_discount');
      var rawMax = qsCheck.get('max_discount');
      if (rawMin !== null) { dMin = Math.max(0, Math.min(100, parseInt(rawMin, 10) || 0)); hasDiscountRange = true; }
      if (rawMax !== null) { dMax = Math.max(0, Math.min(100, parseInt(rawMax, 10) || 100)); hasDiscountRange = true; }
    } catch (e) {}
    cards.forEach(function (card) {
      var ok = true;
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        var wanted = filters[k];
        if (!wanted || !wanted.length) continue;
        var have = card.getAttribute('data-spec-' + k);
        if (!have || wanted.indexOf(have) === -1) { ok = false; break; }
      }
      if (ok && onSaleOnly && card.getAttribute('data-on-sale') !== '1') ok = false;
      // Discount % range filter (works only on Specials page where slider exists)
      if (ok && hasDiscountRange) {
        var pct = parseInt(card.getAttribute('data-discount-pct') || '0', 10);
        if (pct < dMin || pct > dMax) ok = false;
      }
      // Availability filter — client-side fallback
      if (ok && inStockOnly && card.getAttribute('data-available') !== '1') ok = false;
      if (ok && outOfStockOnly && card.getAttribute('data-available') !== '0') ok = false;
      // Also respect client-side avail toggle
      if (ok && card.getAttribute('data-avail-hidden') === '1') ok = false;
      // Mark match state — used by client-side paginator.
      card.setAttribute('data-cf-match', ok ? '1' : '0');
      // Also toggle visibility for the pre-auto-load state and for the
      // empty-state notice logic below (renderClientPage will then further
      // restrict to the current page slice).
      if (!allPagesLoaded) card.style.display = ok ? '' : 'none';
      if (ok) visibleCount++;
    });
    return { total: cards.length, visible: visibleCount };
  }

  // Client-side pagination: only show CLIENT_PER_PAGE matching cards per page.
  function renderClientPage(pageNum) {
    var matching = Array.from(document.querySelectorAll('[data-product-card-wrap][data-cf-match="1"]'));
    var totalMatch = matching.length;
    var totalPages = Math.max(1, Math.ceil(totalMatch / CLIENT_PER_PAGE));
    if (!pageNum || pageNum < 1) pageNum = 1;
    if (pageNum > totalPages) pageNum = totalPages;
    currentClientPage = pageNum;

    var start = (pageNum - 1) * CLIENT_PER_PAGE;
    var end = start + CLIENT_PER_PAGE;

    // Hide everything first, then reveal only this page's slice.
    document.querySelectorAll('[data-product-card-wrap]').forEach(function (card) {
      card.style.display = 'none';
    });
    matching.slice(start, end).forEach(function (card) {
      card.style.display = '';
    });

    renderClientPaginator(pageNum, totalPages, totalMatch);

    // Sync URL ?page=N (replaceState so we don't pollute history with every click).
    try {
      var u = new URL(window.location.href);
      if (pageNum > 1) u.searchParams.set('page', String(pageNum));
      else u.searchParams.delete('page');
      window.history.replaceState({ clientPage: pageNum }, '', u.pathname + (u.search ? u.search : ''));
    } catch (e) {}
  }

  function ensureClientPaginatorEl() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return null;
    var p = document.querySelector('[data-cf-client-paginator]');
    if (!p) {
      p = document.createElement('nav');
      p.setAttribute('data-cf-client-paginator', '');
      p.setAttribute('role', 'navigation');
      p.setAttribute('aria-label', 'Pagination');
      p.className = 'cf-pagination';
      grid.parentNode.insertBefore(p, grid.nextSibling);
    }
    return p;
  }

  function renderClientPaginator(page, totalPages, totalMatch) {
    var nav = ensureClientPaginatorEl();
    if (!nav) return;
    // Remove any stale info paragraph
    var oldInfo = document.querySelector('[data-cf-client-paginator-info]');
    if (oldInfo) oldInfo.remove();

    if (totalPages <= 1) {
      nav.innerHTML = '';
      nav.style.display = 'none';
      if (totalMatch > 0) {
        var info0 = document.createElement('p');
        info0.setAttribute('data-cf-client-paginator-info', '');
        info0.className = 'cf-pagination-info';
        info0.textContent = totalMatch + (totalMatch === 1 ? ' product' : ' products');
        nav.parentNode.insertBefore(info0, nav.nextSibling);
      }
      return;
    }
    nav.style.display = '';

    // Build a compact pages array with ellipses: always show first, last,
    // and pages around the current.
    var pages = [];
    var around = 1;
    var added = {};
    function push(n) { if (n >= 1 && n <= totalPages && !added[n]) { pages.push(n); added[n] = true; } }
    push(1);
    for (var p = page - around; p <= page + around; p++) push(p);
    push(totalPages);
    pages.sort(function (a, b) { return a - b; });

    var html = '';
    // Previous
    if (page > 1) {
      html += '<a href="#" class="cf-page cf-page-nav" data-cf-page="' + (page - 1) + '" aria-label="Previous"><i class="fa-solid fa-chevron-left"></i><span>Previous</span></a>';
    } else {
      html += '<span class="cf-page cf-page-nav is-disabled" aria-hidden="true"><i class="fa-solid fa-chevron-left"></i><span>Previous</span></span>';
    }
    html += '<ul class="cf-page-list">';
    var prev = 0;
    pages.forEach(function (n) {
      if (prev && n > prev + 1) {
        html += '<li><span class="cf-page is-ellipsis">…</span></li>';
      }
      if (n === page) {
        html += '<li><span class="cf-page is-current" aria-current="page">' + n + '</span></li>';
      } else {
        html += '<li><a href="#" class="cf-page" data-cf-page="' + n + '">' + n + '</a></li>';
      }
      prev = n;
    });
    html += '</ul>';
    // Next
    if (page < totalPages) {
      html += '<a href="#" class="cf-page cf-page-nav" data-cf-page="' + (page + 1) + '" aria-label="Next"><span>Next</span><i class="fa-solid fa-chevron-right"></i></a>';
    } else {
      html += '<span class="cf-page cf-page-nav is-disabled" aria-hidden="true"><span>Next</span><i class="fa-solid fa-chevron-right"></i></span>';
    }
    nav.innerHTML = html;

    var info = document.createElement('p');
    info.setAttribute('data-cf-client-paginator-info', '');
    info.className = 'cf-pagination-info';
    info.textContent = 'Page ' + page + ' of ' + totalPages + ' — ' + totalMatch + (totalMatch === 1 ? ' product' : ' products');
    nav.parentNode.insertBefore(info, nav.nextSibling);
  }

  // Delegate paginator clicks
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cf-page]');
    if (!a) return;
    var nav = a.closest('[data-cf-client-paginator]');
    if (!nav) return;
    e.preventDefault();
    var n = parseInt(a.getAttribute('data-cf-page'), 10) || 1;
    renderClientPage(n);
    // Scroll to top of the grid for a clean page change.
    var grid = document.querySelector('.product-grid');
    if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function syncSpecCheckboxes(filters) {
    document.querySelectorAll('.cf-spec-check').forEach(function (cb) {
      var k = cb.getAttribute('data-spec-key');
      var v = cb.getAttribute('data-spec-value');
      cb.checked = !!(filters[k] && filters[k].indexOf(v) !== -1);
    });
  }

  function renderEmptyStateNotice(stats) {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var existing = document.querySelector('[data-cf-empty-notice]');
    if (stats.total > 0 && stats.visible === 0) {
      if (!existing) {
        var n = document.createElement('div');
        n.setAttribute('data-cf-empty-notice', '');
        n.className = 'cf-empty-notice';
        n.innerHTML = '<i class="fa-solid fa-filter-circle-xmark"></i> ' +
          'No products on this page match your filters. ' +
          'Try the other pages or <a href="#" data-cf-clear-filters>clear all filters</a>.';
        grid.parentNode.insertBefore(n, grid);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function applyAndUpdate(filters) {
    var stats = applySpecFiltersToCards(filters);
    renderEmptyStateNotice(stats);
  }

  // Build a filters object from the currently-checked spec inputs (live in DOM).
  function readSpecFiltersFromForm() {
    var out = {};
    document.querySelectorAll('.cf-spec-check:checked').forEach(function (cb) {
      var k = cb.getAttribute('data-spec-key');
      var v = cb.getAttribute('data-spec-value');
      if (!k || !v) return;
      if (!out[k]) out[k] = [];
      if (out[k].indexOf(v) === -1) out[k].push(v);
    });
    return out;
  }

  // Initial sync from URL -> checkboxes + product visibility.
  var initialFilters = readSpecFiltersFromUrl();
  syncSpecCheckboxes(initialFilters);
  // Sync on-sale checkbox from URL
  (function syncOnSaleFromUrl() {
    try {
      var qs = new URLSearchParams(window.location.search);
      var on = qs.get('on_sale') === '1';
      // Availability filter — pure client-side handler for parent collections
  // and anywhere S&D native availability filter is not configured.
  // Uses data-avail-toggle="1" (in stock) / "0" (out of stock).
  function applyAvailFilter() {
    var inStock  = document.querySelector('[data-avail-toggle="1"]:checked');
    var outStock = document.querySelector('[data-avail-toggle="0"]:checked');
    if (!inStock && !outStock) {
      // Nothing checked — show all cards (restore any hidden by this filter)
      document.querySelectorAll('[data-product-card-wrap]').forEach(function (card) {
        card.removeAttribute('data-avail-hidden');
        if (card.getAttribute('data-cf-match') !== '0') {
          card.style.display = '';
        }
      });
      sortGridTiered();
      return;
    }
    document.querySelectorAll('[data-product-card-wrap]').forEach(function (card) {
      var avail = card.getAttribute('data-available') === '1';
      var show  = true;
      if (inStock  && !avail) show = false;
      if (outStock &&  avail) show = false;
      card.setAttribute('data-avail-hidden', show ? '0' : '1');
      if (!show) {
        card.style.display = 'none';
      } else if (card.getAttribute('data-cf-match') !== '0') {
        card.style.display = '';
      }
    });
    sortGridTiered();
  }

  document.querySelectorAll('[data-avail-toggle]').forEach(function (cb) {
    cb.addEventListener('change', function(e) {
      // Prevent native form submit for availability — handle client-side
      e.stopPropagation();
      applyAvailFilter();
    });
  });

  // Also apply on page load if URL has avail= param
  (function () {
    try {
      var qs = new URLSearchParams(window.location.search);
      var av = qs.get('avail');
      if (av === '1' || av === '0') {
        var cb = document.querySelector('[data-avail-toggle="' + av + '"]');
        if (cb) { cb.checked = true; applyAvailFilter(); }
      }
    } catch (e) {}
  })();

  document.querySelectorAll('[data-on-sale-toggle]').forEach(function (cb) { cb.checked = on; });
    } catch (e) {}
  })();
  applyAndUpdate(initialFilters);

  // ---- Cross-page client-side filtering + global ordering ------------------
  // Two scenarios both require fetching every page of the current collection:
  //   1. The user has activated a client-side filter (`spec.*`, `on_sale`) and
  //      we need to filter across ALL products, not just the current page.
  //   2. The collection has more than one page — without auto-loading, the
  //      "best-seller → on-sale → rest → OOS" tier ordering only applies
  //      within each paginated page (so e.g. OOS items still appear in the
  //      middle of page 2 instead of at the very end of the catalogue).
  // We therefore auto-load every page on any paginated collection AND on any
  // filter activation.
  var allPagesLoaded = false;
  var allPagesLoading = false;

  function isAnyClientFilterActive() {
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.get('on_sale') === '1') return true;
      if (qs.has('min_discount') || qs.has('max_discount')) return true;
      var keys = Array.from(qs.keys());
      for (var i = 0; i < keys.length; i++) if (keys[i].indexOf('spec.') === 0) return true;
    } catch (e) {}
    if (document.querySelector('[data-on-sale-toggle]:checked')) return true;
    if (document.querySelector('.cf-spec-check:checked')) return true;
    if (document.querySelector('[data-discount-filter]')) {
      var mn = document.querySelector('[data-discount-min]');
      var mx = document.querySelector('[data-discount-max]');
      if (mn && parseInt(mn.value, 10) > 0) return true;
      if (mx && parseInt(mx.value, 10) < 100) return true;
    }
    return false;
  }

  function isPaginatedCollection() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return false;
    return grid.getAttribute('data-paginated-collection') === '1';
  }

  // Auto-load threshold: fetch all pages client-side for tier-sort.
  // Subcategories (<300 products) auto-load and tier-sort correctly.
  // Parent collections use Best Selling sort order set in Shopify Admin.
  var MAX_AUTOLOAD_PRODUCTS = 1000;

  function shouldAutoLoadAllPages() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return false;
    if (!getCollectionHandleFromPath()) return false;
    var totalProducts = parseInt(grid.getAttribute('data-total-products') || '0', 10);
    if (totalProducts > MAX_AUTOLOAD_PRODUCTS) return false;
    return isPaginatedCollection() || isAnyClientFilterActive();
  }

  function getCollectionHandleFromPath() {
    var grid = document.querySelector('.product-grid');
    if (grid && grid.getAttribute('data-collection-handle')) {
      return grid.getAttribute('data-collection-handle');
    }
    var m = window.location.pathname.match(/^\/collections\/([^\/?]+)/i);
    return m ? m[1] : null;
  }

  function ensureCrossPageNotice() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return null;
    var n = document.querySelector('[data-cf-cross-notice]');
    if (!n) {
      n = document.createElement('div');
      n.setAttribute('data-cf-cross-notice', '');
      n.setAttribute('data-testid', 'cf-cross-page-notice');
      n.className = 'cf-cross-notice';
      n.style.cssText = 'display:flex;align-items:center;gap:.5rem;padding:.6rem .9rem;margin:0 0 1rem;border-radius:.5rem;background:#eff6ff;color:#1e3a8a;font-size:.875rem;border:1px solid #bfdbfe;';
      grid.parentNode.insertBefore(n, grid);
    }
    return n;
  }

  function setCrossPageNotice(msg, kind) {
    var n = ensureCrossPageNotice();
    if (!n) return;
    var palette = {
      info:    'background:#eff6ff;color:#1e3a8a;border-color:#bfdbfe;',
      success: 'background:#ecfdf5;color:#065f46;border-color:#a7f3d0;'
    };
    n.style.cssText = 'display:flex;align-items:center;gap:.5rem;padding:.6rem .9rem;margin:0 0 1rem;border-radius:.5rem;font-size:.875rem;border:1px solid;' + (palette[kind] || palette.info);
    n.innerHTML = msg;
  }
  function removeCrossPageNotice() {
    var n = document.querySelector('[data-cf-cross-notice]');
    if (n) n.remove();
  }

  function hidePagination() {
    var p = document.querySelector('.cf-pagination');
    if (p) p.style.display = 'none';
    var pi = document.querySelector('.cf-pagination-info');
    if (pi) pi.style.display = 'none';
  }

  // Reorder cards in the grid by tier: best-seller → on-sale → rest → OOS.
  // Preserves the within-tier order (which is the collection's natural sort).
  function sortGridTiered() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll(':scope > [data-product-card-wrap]'));
    if (cards.length < 2) return;
    function tierOf(card) {
      var avail = card.getAttribute('data-available') === '1';
      var bs    = card.getAttribute('data-best-seller') === '1';
      var sale  = card.getAttribute('data-on-sale') === '1';
      if (!avail) return 4;        // OOS last
      if (bs)     return 1;        // in-stock best-seller first
      if (sale)   return 2;        // in-stock on sale
      return 3;                    // in-stock rest
    }
    // Decorate-sort-undecorate to keep within-tier order stable.
    cards.forEach(function (c, i) { c.__idx = i; c.__tier = tierOf(c); });
    cards.sort(function (a, b) {
      if (a.__tier !== b.__tier) return a.__tier - b.__tier;
      return a.__idx - b.__idx;
    });
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);
  }

  // Re-run tier sort after each page batch is inserted into the grid
  function sortAfterLoad() {
    sortGridTiered();
  }

  async function fetchCardsBatch(handle, page) {
    // Forward native Shopify filter params (filter.*, sort_by, etc.) so the
    // cards-only view respects them. Drop client-only params (spec.*, on_sale,
    // page) — we set page ourselves and handle spec/on_sale client-side.
    var qs = new URLSearchParams();
    try {
      var src = new URLSearchParams(window.location.search);
      src.forEach(function (val, key) {
        if (key === 'page') return;
        if (key === 'on_sale') return;
        if (key === 'min_discount' || key === 'max_discount') return;
        if (key.indexOf('spec.') === 0) return;
        if (val) qs.append(key, val);
      });
    } catch (e) {}
    qs.set('view', 'cards-only');
    qs.set('page', String(page));
    // 2026-10-03: locale-aware — on /fr/ the cards must come from /fr/collections/… so titles, buttons,
    // badges and product links render in French (they came back English before, whatever the storefront language).
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'collections/' + encodeURIComponent(handle) + '?' + qs.toString();
    var res = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var batch = doc.querySelector('[data-cards-batch]');
    return batch;
  }

  async function loadAllPagesIfFiltering() {
    if (allPagesLoaded || allPagesLoading) return;
    if (!shouldAutoLoadAllPages()) return;
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var handle = getCollectionHandleFromPath();
    if (!handle) return;

    var filterActive = isAnyClientFilterActive();
    allPagesLoading = true;
    setCrossPageNotice(
      '<i class="fa-solid fa-spinner fa-spin"></i> <span>' +
        (filterActive ? 'Filtering across all pages…' : 'Loading full collection…') +
      '</span>',
      'info'
    );

    // Backup so we can roll back on failure.
    var gridBackup = grid.innerHTML;

    try {
      // Determine total pages — use server-rendered hint if available,
      // otherwise discover via the first batch's `data-has-more`.
      var grid2 = grid;
      var totalPagesHint = parseInt(grid2.getAttribute('data-total-pages') || '0', 10);
      var totalAppended = 0;

      if (totalPagesHint > 1) {
        // We know the page count up-front — fetch all pages in parallel.
        // Pad by 1 in case the cards-only template's pagination size (50) is
        // different from the merchant's collection per-page setting (default 48).
        var maxPages = Math.min(totalPagesHint + 1, 100);
        var promises = [];
        for (var p = 1; p <= maxPages; p++) {
          promises.push(fetchCardsBatch(handle, p).catch(function () { return null; }));
        }
        var batches = await Promise.all(promises);
        grid.innerHTML = '';
        batches.forEach(function (b) {
          if (!b) return;
          Array.from(b.children).forEach(function (card) {
            grid.appendChild(card);
            totalAppended++;
          });
        });
      } else {
        // Fallback: discover page count sequentially.
        var page = 1;
        var safety = 100;
        var firstBatch = await fetchCardsBatch(handle, page);
        if (!firstBatch) throw new Error('Empty first batch');
        grid.innerHTML = '';
        Array.from(firstBatch.children).forEach(function (card) {
          grid.appendChild(card);
          totalAppended++;
        });
        var hasMore = firstBatch.getAttribute('data-has-more') === '1';
        page = 2;
        while (hasMore && safety-- > 0) {
          var batch = await fetchCardsBatch(handle, page);
          if (!batch) break;
          Array.from(batch.children).forEach(function (card) {
            grid.appendChild(card);
            totalAppended++;
          });
          hasMore = batch.getAttribute('data-has-more') === '1';
          page++;
        }
      }

      hidePagination();
      allPagesLoaded = true;

      // Read the requested page from URL (server-pagination's `?page=N`
      // becomes our client-pagination page) so users landing on /page=2 stay
      // on page 2 after the full sort is applied.
      var requestedPage = 1;
      try {
        var u0 = new URL(window.location.href);
        requestedPage = parseInt(u0.searchParams.get('page') || '1', 10) || 1;
      } catch (e) {}

      // Reorder all cards now that the full set is in the DOM
      sortGridTiered();

      // Re-apply current filters now that all cards are in the DOM.
      var current = readSpecFiltersFromForm();
      var stats = applySpecFiltersToCards(current);

      // Apply client-side pagination on top.
      renderClientPage(requestedPage);

      if (isAnyClientFilterActive()) {
        setCrossPageNotice(
          '<i class="fa-solid fa-circle-check"></i> <span>Filtering across ' + totalAppended + ' products — <strong>' + stats.visible + '</strong> match.</span>',
          'success'
        );
      } else {
        // No filter: don't pollute the page with a notice. Just remove it.
        removeCrossPageNotice();
      }
    } catch (err) {
      // On failure, restore original grid and remove the notice.
      grid.innerHTML = gridBackup;
      removeCrossPageNotice();
      if (window.console) console.warn('Cross-page filter load failed:', err);
    } finally {
      allPagesLoading = false;
    }
  }

  // Kick off cross-page loading on initial paint if URL already has filters.
  loadAllPagesIfFiltering();

  // Re-render the client page when the user uses browser back/forward.
  window.addEventListener('popstate', function () {
    if (!allPagesLoaded) return;
    try {
      var u = new URL(window.location.href);
      var p = parseInt(u.searchParams.get('page') || '1', 10) || 1;
      renderClientPage(p);
    } catch (e) {}
  });
  // -----------------------------------------------------------------------

  // Persist spec.* params across pagination links so filters survive page hops.
  (function persistSpecOnPagination() {
    var specQs = [];
    try {
      var qs = new URLSearchParams(window.location.search);
      qs.forEach(function (v, k) { if (k.indexOf('spec.') === 0 || k === 'on_sale') specQs.push(k + '=' + encodeURIComponent(v)); });
    } catch (e) {}
    if (!specQs.length) return;
    document.querySelectorAll('.cf-pagination a.cf-page').forEach(function (a) {
      try {
        var u = new URL(a.href, window.location.origin);
        specQs.forEach(function (pair) {
          var kv = pair.split('=');
          u.searchParams.set(kv[0], decodeURIComponent(kv[1]));
        });
        a.href = u.pathname + (u.search ? u.search : '');
      } catch (e) {}
    });
  })();

  // Re-apply on live checkbox changes for instant feedback (no submit needed).
  document.querySelectorAll('.cf-spec-check').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var f = readSpecFiltersFromForm();
      applyAndUpdate(f);
      if (!allPagesLoaded) {
        // First filter activation — go load the rest of the collection.
        loadAllPagesIfFiltering();
      } else {
        var stats = applySpecFiltersToCards(f);
        renderClientPage(1);
        if (!isAnyClientFilterActive()) {
          removeCrossPageNotice();
        } else {
          var total = document.querySelectorAll('[data-product-card-wrap]').length;
          setCrossPageNotice(
            '<i class="fa-solid fa-circle-check"></i> <span>Filtering across ' + total + ' products — <strong>' + stats.visible + '</strong> match.</span>',
            'success'
          );
        }
      }
    });
  });

  // On-sale toggle: instant client-side filter + persist in URL.
  // Availability filter — pure client-side handler for parent collections
  // and anywhere S&D native availability filter is not configured.
  // Uses data-avail-toggle="1" (in stock) / "0" (out of stock).
  function applyAvailFilter() {
    var inStock  = document.querySelector('[data-avail-toggle="1"]:checked');
    var outStock = document.querySelector('[data-avail-toggle="0"]:checked');
    if (!inStock && !outStock) {
      // Nothing checked — show all cards (restore any hidden by this filter)
      document.querySelectorAll('[data-product-card-wrap]').forEach(function (card) {
        card.removeAttribute('data-avail-hidden');
        if (card.getAttribute('data-cf-match') !== '0') {
          card.style.display = '';
        }
      });
      sortGridTiered();
      return;
    }
    document.querySelectorAll('[data-product-card-wrap]').forEach(function (card) {
      var avail = card.getAttribute('data-available') === '1';
      var show  = true;
      if (inStock  && !avail) show = false;
      if (outStock &&  avail) show = false;
      card.setAttribute('data-avail-hidden', show ? '0' : '1');
      if (!show) {
        card.style.display = 'none';
      } else if (card.getAttribute('data-cf-match') !== '0') {
        card.style.display = '';
      }
    });
    sortGridTiered();
  }

  document.querySelectorAll('[data-avail-toggle]').forEach(function (cb) {
    cb.addEventListener('change', function(e) {
      // Prevent native form submit for availability — handle client-side
      e.stopPropagation();
      applyAvailFilter();
    });
  });

  // Also apply on page load if URL has avail= param
  (function () {
    try {
      var qs = new URLSearchParams(window.location.search);
      var av = qs.get('avail');
      if (av === '1' || av === '0') {
        var cb = document.querySelector('[data-avail-toggle="' + av + '"]');
        if (cb) { cb.checked = true; applyAvailFilter(); }
      }
    } catch (e) {}
  })();

  document.querySelectorAll('[data-on-sale-toggle]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      try {
        var u = new URL(window.location.href);
        if (cb.checked) u.searchParams.set('on_sale', '1');
        else u.searchParams.delete('on_sale');
        window.history.replaceState({}, '', u.pathname + (u.search ? u.search : ''));
      } catch (e) {}
      var f = readSpecFiltersFromForm();
      applyAndUpdate(f);
      if (!allPagesLoaded) {
        loadAllPagesIfFiltering();
      } else {
        var stats = applySpecFiltersToCards(f);
        renderClientPage(1);
        if (!isAnyClientFilterActive()) {
          removeCrossPageNotice();
        } else {
          var total = document.querySelectorAll('[data-product-card-wrap]').length;
          setCrossPageNotice(
            '<i class="fa-solid fa-circle-check"></i> <span>Filtering across ' + total + ' products — <strong>' + stats.visible + '</strong> match.</span>',
            'success'
          );
        }
      }
    });
  });

  // ---- Discount % range slider (Specials page) ----
  (function () {
    var wrap = document.querySelector('[data-discount-filter]');
    if (!wrap) return;
    var minInput = wrap.querySelector('[data-discount-min]');
    var maxInput = wrap.querySelector('[data-discount-max]');
    var minLabel = wrap.querySelector('[data-discount-min-label]');
    var maxLabel = wrap.querySelector('[data-discount-max-label]');
    var track    = wrap.querySelector('[data-discount-range]') && wrap.querySelector('[data-discount-range]').parentNode;
    var presets  = wrap.querySelectorAll('[data-discount-preset]');
    if (!minInput || !maxInput) return;

    var commitTimer = null;

    function paintTrack() {
      if (!track) return;
      var mn = parseInt(minInput.value, 10);
      var mx = parseInt(maxInput.value, 10);
      track.style.setProperty('--cf-track-pct-min', mn + '%');
      track.style.setProperty('--cf-track-pct-max', mx + '%');
    }
    function syncPresets() {
      var mn = parseInt(minInput.value, 10);
      var mx = parseInt(maxInput.value, 10);
      presets.forEach(function (b) {
        var v = parseInt(b.getAttribute('data-discount-preset'), 10);
        b.classList.toggle('is-active', mn === v && mx === 100);
      });
    }
    function clampPair() {
      var mn = parseInt(minInput.value, 10);
      var mx = parseInt(maxInput.value, 10);
      if (mn > mx - 5) {
        // Keep at least 5% gap between thumbs
        if (this === minInput) minInput.value = String(Math.max(0, mx - 5));
        else maxInput.value = String(Math.min(100, mn + 5));
      }
    }
    function updateLabels() {
      if (minLabel) minLabel.textContent = minInput.value;
      if (maxLabel) maxLabel.textContent = maxInput.value;
    }
    function commitUrlAndFilter() {
      var mn = parseInt(minInput.value, 10);
      var mx = parseInt(maxInput.value, 10);
      try {
        var u = new URL(window.location.href);
        if (mn > 0) u.searchParams.set('min_discount', String(mn));
        else u.searchParams.delete('min_discount');
        if (mx < 100) u.searchParams.set('max_discount', String(mx));
        else u.searchParams.delete('max_discount');
        window.history.replaceState({}, '', u.pathname + (u.search ? u.search : ''));
      } catch (e) {}
      var f = readSpecFiltersFromForm();
      if (!allPagesLoaded) {
        loadAllPagesIfFiltering();
      } else {
        var stats = applySpecFiltersToCards(f);
        renderClientPage(1);
        if (!isAnyClientFilterActive()) {
          removeCrossPageNotice();
        } else {
          var total = document.querySelectorAll('[data-product-card-wrap]').length;
          setCrossPageNotice(
            '<i class="fa-solid fa-percent"></i> <span>Showing items <strong>' + mn + '%–' + mx + '%</strong> off — <strong>' + stats.visible + '</strong> match.</span>',
            'success'
          );
        }
      }
    }
    function onInput() {
      clampPair.call(this);
      paintTrack();
      updateLabels();
      syncPresets();
      // Debounce URL+filter commit while dragging
      if (commitTimer) clearTimeout(commitTimer);
      commitTimer = setTimeout(commitUrlAndFilter, 180);
    }

    minInput.addEventListener('input', onInput);
    maxInput.addEventListener('input', onInput);
    minInput.addEventListener('change', commitUrlAndFilter);
    maxInput.addEventListener('change', commitUrlAndFilter);

    presets.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = parseInt(b.getAttribute('data-discount-preset'), 10) || 0;
        minInput.value = String(v);
        maxInput.value = '100';
        paintTrack();
        updateLabels();
        syncPresets();
        commitUrlAndFilter();
      });
    });

    // Initial paint on load
    paintTrack();
    updateLabels();
    syncPresets();
  })();

  // Delegate "clear all filters" links in the empty-state notice.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cf-clear-filters]');
    if (!t) return;
    e.preventDefault();
    document.querySelectorAll('.cf-spec-check').forEach(function (cb) { cb.checked = false; });
    // Availability filter — pure client-side handler for parent collections
  // and anywhere S&D native availability filter is not configured.
  // Uses data-avail-toggle="1" (in stock) / "0" (out of stock).
  function applyAvailFilter() {
    var inStock  = document.querySelector('[data-avail-toggle="1"]:checked');
    var outStock = document.querySelector('[data-avail-toggle="0"]:checked');
    if (!inStock && !outStock) {
      // Nothing checked — show all cards (restore any hidden by this filter)
      document.querySelectorAll('[data-product-card-wrap]').forEach(function (card) {
        card.removeAttribute('data-avail-hidden');
        if (card.getAttribute('data-cf-match') !== '0') {
          card.style.display = '';
        }
      });
      sortGridTiered();
      return;
    }
    document.querySelectorAll('[data-product-card-wrap]').forEach(function (card) {
      var avail = card.getAttribute('data-available') === '1';
      var show  = true;
      if (inStock  && !avail) show = false;
      if (outStock &&  avail) show = false;
      card.setAttribute('data-avail-hidden', show ? '0' : '1');
      if (!show) {
        card.style.display = 'none';
      } else if (card.getAttribute('data-cf-match') !== '0') {
        card.style.display = '';
      }
    });
    sortGridTiered();
  }

  document.querySelectorAll('[data-avail-toggle]').forEach(function (cb) {
    cb.addEventListener('change', function(e) {
      // Prevent native form submit for availability — handle client-side
      e.stopPropagation();
      applyAvailFilter();
    });
  });

  // Also apply on page load if URL has avail= param
  (function () {
    try {
      var qs = new URLSearchParams(window.location.search);
      var av = qs.get('avail');
      if (av === '1' || av === '0') {
        var cb = document.querySelector('[data-avail-toggle="' + av + '"]');
        if (cb) { cb.checked = true; applyAvailFilter(); }
      }
    } catch (e) {}
  })();

  document.querySelectorAll('[data-on-sale-toggle]').forEach(function (cb) { cb.checked = false; });
    var url = window.location.pathname;
    var qs = new URLSearchParams(window.location.search);
    Array.from(qs.keys()).forEach(function (k) { if (k.indexOf('spec.') === 0) qs.delete(k); });
    qs.delete('on_sale');
    qs.delete('min_discount');
    qs.delete('max_discount');
    var qss = qs.toString();
    window.location.href = url + (qss ? '?' + qss : '');
  });

  // On form submit: bundle the checked specs into ?spec.<key>=<v1>,<v2>... and
  // keep all native filter.* / sort_by / availability / price params.
  document.querySelectorAll('[data-collection-filters]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var specs = readSpecFiltersFromForm();
      var hasClientFilters = Object.keys(specs).some(function (k) { return specs[k].length > 0; });
      var onSaleCb = form.querySelector('[data-on-sale-toggle]');
      var hasOnSale = onSaleCb && onSaleCb.checked;
      // Discount slider state (if present)
      var dMinEl = form.querySelector('[data-discount-min]');
      var dMaxEl = form.querySelector('[data-discount-max]');
      var dMinV = dMinEl ? parseInt(dMinEl.value, 10) : 0;
      var dMaxV = dMaxEl ? parseInt(dMaxEl.value, 10) : 100;
      var hasDiscountRange = (dMinEl || dMaxEl) && (dMinV > 0 || dMaxV < 100);

      // If NO client-side filters (spec.* or on_sale or discount range) are active,
      // let the form submit natively so Search & Discovery filters
      // (availability, price, etc.) work with a proper server-side reload.
      if (!hasClientFilters && !hasOnSale && !hasDiscountRange) {
        return; // native submit — no preventDefault
      }

      // Client-side filters active — intercept and build custom URL
      e.preventDefault();

      var action = form.getAttribute('action') || window.location.pathname;
      var base = action.split('?')[0];

      var params = new URLSearchParams();
      // Native form fields first (price, availability, sort_by, etc.)
      new FormData(form).forEach(function (val, key) {
        if (val === '' || val == null) return;
        params.append(key, val);
      });
      // Drop the raw slider values that FormData picked up — we control them below
      params.delete('min_discount');
      params.delete('max_discount');
      // Append spec.* params
      Object.keys(specs).forEach(function (k) {
        if (specs[k].length) params.set('spec.' + k, specs[k].join(','));
      });
      // Append on_sale param if checked
      if (hasOnSale) params.set('on_sale', '1');
      else params.delete('on_sale');
      // Discount range (only if narrowed)
      if (dMinV > 0) params.set('min_discount', String(dMinV));
      if (dMaxV < 100) params.set('max_discount', String(dMaxV));

      var qs = params.toString();
      window.location.href = base + (qs ? '?' + qs : '');
    });
  });

  // ---- Mobile sidebar toggle (collection page) ----
  var cfMobileOpen = document.querySelector('[data-cf-mobile-open]');
  var cfSidebar = document.querySelector('[data-cf-sidebar]');
  var cfBackdrop = document.querySelector('[data-cf-backdrop]');
  var cfMobileCloseBtns = document.querySelectorAll('[data-cf-mobile-close]');

  function openCfSidebar() {
    if (!cfSidebar) return;
    cfSidebar.classList.add('is-open');
    if (cfBackdrop) cfBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCfSidebar() {
    if (!cfSidebar) return;
    cfSidebar.classList.remove('is-open');
    if (cfBackdrop) cfBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cfMobileOpen) cfMobileOpen.addEventListener('click', openCfSidebar);
  cfMobileCloseBtns.forEach(function (b) { b.addEventListener('click', closeCfSidebar); });
  if (cfBackdrop) cfBackdrop.addEventListener('click', closeCfSidebar);

  // ---- PDP filter drawer ----
  var pdpOpenBtn = document.querySelector('[data-pdp-filter-open]');
  var pdpDrawer = document.querySelector('[data-pdp-filter-drawer]');
  var pdpCloseBtns = document.querySelectorAll('[data-pdp-filter-close]');

  function openPdpDrawer() {
    if (!pdpDrawer) return;
    pdpDrawer.classList.add('is-open');
    pdpDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closePdpDrawer() {
    if (!pdpDrawer) return;
    pdpDrawer.classList.remove('is-open');
    pdpDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (pdpOpenBtn) pdpOpenBtn.addEventListener('click', openPdpDrawer);
  pdpCloseBtns.forEach(function (b) { b.addEventListener('click', closePdpDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (pdpDrawer && pdpDrawer.classList.contains('is-open')) closePdpDrawer();
      if (cfSidebar && cfSidebar.classList.contains('is-open')) closeCfSidebar();
    }
  });
});


/* ============================================
   ACCOUNT DASHBOARD — tabs, wishlist, reorder, toasts
   ============================================ */
(function () {
  'use strict';

  // ---------- Toast helper ----------
  function showToast(message, type) {
    type = type || 'success';
    var host = document.querySelector('.atc-toast-container');
    if (!host) {
      host = document.createElement('div');
      host.className = 'atc-toast-container account-toast-host';
      document.body.appendChild(host);
    }
    var toast = document.createElement('div');
    toast.className = 'atc-toast' + (type === 'error' ? ' atc-toast--error' : '');
    var icon = type === 'error' ? 'fa-circle-xmark' : 'fa-circle-check';
    toast.innerHTML =
      '<div class="atc-toast-icon"><i class="fa-solid ' + icon + '"></i></div>' +
      '<div class="atc-toast-body"><div class="atc-toast-title">' + message + '</div></div>';
    host.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('atc-toast--show'); });
    setTimeout(function () {
      toast.classList.remove('atc-toast--show');
      setTimeout(function () { toast.remove(); }, 300);
    }, 2500);
  }

  // ---------- Wishlist (localStorage) ----------
  var WISHLIST_KEY = 'sbpak_wishlist';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      return Array.isArray(data) ? data : [];
    } catch (e) { return []; }
  }

  function writeWishlist(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (e) {}
    syncWishlistUI();
  }

  function inWishlist(id) {
    return readWishlist().some(function (item) { return String(item.id) === String(id); });
  }

  function toggleWishlist(payload) {
    var items = readWishlist();
    var idx = items.findIndex(function (item) { return String(item.id) === String(payload.id); });
    if (idx >= 0) {
      items.splice(idx, 1);
      writeWishlist(items);
      return false;
    }
    items.unshift(payload);
    writeWishlist(items);
    return true;
  }

  function syncWishlistUI() {
    var items = readWishlist();

    // Update all heart buttons on page
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-id');
      var active = items.some(function (i) { return String(i.id) === String(id); });
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    // Update count badges
    var count = items.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-wishlist-stat]').forEach(function (el) {
      el.textContent = count;
    });

    // Render wishlist grid
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (grid) {
      grid.innerHTML = '';
      if (items.length === 0) {
        grid.style.display = 'none';
        if (empty) empty.style.display = '';
      } else {
        grid.style.display = '';
        if (empty) empty.style.display = 'none';
        items.forEach(function (item) {
          grid.appendChild(buildWishlistCard(item));
        });
      }
    }
  }

  function buildWishlistCard(item) {
    var wrap = document.createElement('div');
    wrap.className = 'product-card-wrap';
    var saleBadge = item.onSale === '1' || item.onSale === 1
      ? '<span class="product-card-badge">' + (window.__locale && window.__locale.sale || 'SALE') + '</span>' : '';
    var oosBadge = item.available === '0' || item.available === 0
      ? '<span class="product-card-badge product-card-badge--oos">' + (window.__locale && window.__locale.outOfStock || 'Out of Stock') + '</span>' : '';
    var compare = item.comparePrice && item.onSale === '1'
      ? '<span class="product-card-compare-price">' + item.comparePrice + '</span>' : '';
    var atcLabel = window.__locale && window.__locale.addToCart || 'Add to Cart';
    var notifyLabel = window.__locale && window.__locale.notify || 'Notify me';
    var cta = (item.available === '1' || item.available === 1)
      ? '<a href="' + item.url + '" class="product-card-atc"><i class="fa-solid fa-cart-shopping"></i>' + atcLabel + '</a>'
      : '<a href="' + item.url + '" class="product-card-atc product-card-atc--notify"><i class="fa-solid fa-bell"></i>' + notifyLabel + '</a>';
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
      : '<div style="width:100%;height:100%;background:var(--color-bg-secondary);"></div>';

    wrap.innerHTML =
      '<button type="button" class="product-card-wishlist is-active" data-wishlist-toggle ' +
        'data-wishlist-id="' + item.id + '" data-wishlist-handle="' + (item.handle || '') + '" ' +
        'data-wishlist-title="' + escapeHtml(item.title || '') + '" data-wishlist-url="' + (item.url || '') + '" ' +
        'data-wishlist-image="' + (item.image || '') + '" data-wishlist-price="' + (item.price || '') + '" ' +
        'data-wishlist-compare-price="' + (item.comparePrice || '') + '" data-wishlist-on-sale="' + (item.onSale || '0') + '" ' +
        'data-wishlist-available="' + (item.available || '1') + '" aria-label="Remove from wishlist">' +
        '<i class="fa-solid fa-heart"></i></button>' +
      '<a href="' + item.url + '" class="product-card">' +
        '<div class="product-card-image">' + imgHtml + saleBadge + oosBadge + '</div>' +
        '<div class="product-card-body">' +
          '<h3 class="product-card-title">' + escapeHtml(item.title || '') + '</h3>' +
          '<div class="product-card-prices">' +
            '<span class="product-card-price">' + (item.price || '') + '</span>' + compare +
          '</div>' + cta +
        '</div>' +
      '</a>';
    return wrap;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Wishlist click handler (event-delegation)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var payload = {
      id: btn.getAttribute('data-wishlist-id'),
      handle: btn.getAttribute('data-wishlist-handle'),
      title: btn.getAttribute('data-wishlist-title'),
      url: btn.getAttribute('data-wishlist-url'),
      image: btn.getAttribute('data-wishlist-image'),
      price: btn.getAttribute('data-wishlist-price'),
      comparePrice: btn.getAttribute('data-wishlist-compare-price'),
      onSale: btn.getAttribute('data-wishlist-on-sale'),
      available: btn.getAttribute('data-wishlist-available')
    };
    var added = toggleWishlist(payload);
    var msg = added
      ? (window.__locale && window.__locale.wishlistAdded || 'Added to wishlist')
      : (window.__locale && window.__locale.wishlistRemoved || 'Removed from wishlist');
    showToast(msg, 'success');
  });

  // ---------- Account tabs ----------
  function activateTab(name) {
    var root = document.querySelector('[data-account-root]');
    if (!root) return;
    root.querySelectorAll('[data-account-nav] [data-tab]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-tab') === name);
    });
    root.querySelectorAll('[data-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-panel') === name);
    });
    if (history.replaceState) {
      history.replaceState(null, '', '#' + name);
    } else {
      location.hash = name;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var navBtn = e.target.closest('[data-account-nav] [data-tab]');
    if (navBtn) {
      e.preventDefault();
      activateTab(navBtn.getAttribute('data-tab'));
      return;
    }
    var quick = e.target.closest('[data-tab-link]');
    if (quick) {
      e.preventDefault();
      activateTab(quick.getAttribute('data-tab-link'));
      return;
    }
  });

  // ---------- Address inline forms ----------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-address-toggle]');
    if (!t) return;
    e.preventDefault();
    var id = t.getAttribute('data-address-toggle');
    var form = document.querySelector('[data-address-form="' + id + '"]');
    if (form) form.hidden = !form.hidden;
  });

  // ---------- Reorder (adds previous order line items to cart) ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reorder]');
    if (!btn) return;
    e.preventDefault();
    var raw = btn.getAttribute('data-reorder');
    var ids;
    try { ids = JSON.parse(raw); } catch (err) { ids = []; }
    if (!ids.length) return;

    var items = ids.filter(Boolean).map(function (id) { return { id: id, quantity: 1 }; });
    if (!items.length) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (res.ok) {
          showToast(window.__locale && window.__locale.reorderAdded || 'Items added to your cart', 'success');
          // Pulse cart badge
          var cartBadge = document.querySelector('.cart-badge, .header-action-link .badge');
          if (cartBadge) {
            cartBadge.classList.add('is-pulsing');
            setTimeout(function () { cartBadge.classList.remove('is-pulsing'); }, 600);
          }
          // Refresh cart count if helper exists
          if (typeof window.refreshCartUI === 'function') window.refreshCartUI();
          // Soft refresh count
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});
        } else {
          showToast(window.__locale && window.__locale.reorderFailed || "Some items couldn't be re-added", 'error');
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        showToast(window.__locale && window.__locale.reorderFailed || "Some items couldn't be re-added", 'error');
      });
  });

  // ---------- Init on DOM ready ----------
  document.addEventListener('DOMContentLoaded', function () {
    syncWishlistUI();

    // Activate tab from URL hash on load
    var hash = (location.hash || '').replace('#', '');
    var validTabs = ['dashboard', 'orders', 'wishlist', 'addresses', 'profile', 'recent'];
    if (hash && validTabs.indexOf(hash) >= 0) {
      activateTab(hash);
    }

    // Render recently-viewed inside account "recent" panel using existing storage
    renderAccountRecentlyViewed();
  });

  // ---------- Account Recently Viewed renderer ----------
  function renderAccountRecentlyViewed() {
    var track = document.querySelector('[data-panel="recent"] [data-recently-viewed-track]');
    var emptyEl = document.querySelector('[data-recent-empty]');
    if (!track) return;

    var key = 'sb_recently_viewed';
    var items = [];
    try {
      var raw = localStorage.getItem(key);
      if (raw) items = JSON.parse(raw) || [];
    } catch (e) {}

    if (!items.length) {
      track.style.display = 'none';
      if (emptyEl) emptyEl.style.display = '';
      return;
    }

    track.innerHTML = '';
    track.style.display = '';
    if (emptyEl) emptyEl.style.display = 'none';

    items.slice(0, 12).forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'cart-reco-card';
      card.innerHTML = buildSimpleCard(item);
      track.appendChild(card);
    });
  }

  function buildSimpleCard(item) {
    var compare = item.on_sale && item.compare_at_price
      ? '<span class="product-card-compare-price">' + item.compare_at_price + '</span>' : '';
    var sale = item.on_sale ? '<span class="product-card-badge">SALE</span>' : '';
    var img = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '';
    return (
      '<a href="' + item.url + '" class="product-card">' +
        '<div class="product-card-image">' + img + sale + '</div>' +
        '<div class="product-card-body">' +
          '<h3 class="product-card-title">' + escapeHtml(item.title) + '</h3>' +
          '<div class="product-card-prices">' +
            '<span class="product-card-price">' + (item.price || '') + '</span>' + compare +
          '</div>' +
        '</div>' +
      '</a>'
    );
  }
})();

/* ============================================
   LOCALE STRINGS (pulled from data attribute on <html> if present, else defaults)
   ============================================ */
(function () {
  var html = document.documentElement;
  var lang = (html && html.getAttribute('lang') || 'en').toLowerCase();
  var fr = lang.indexOf('fr') === 0;
  window.__locale = window.__locale || {
    addToCart: fr ? 'Ajouter au panier' : 'Add to Cart',
    notify: fr ? "M'aviser" : 'Notify me',
    sale: fr ? 'SOLDE' : 'SALE',
    outOfStock: fr ? 'Rupture' : 'Out of Stock',
    wishlistAdded: fr ? 'Ajouté à la liste de souhaits' : 'Added to wishlist',
    wishlistRemoved: fr ? 'Retiré de la liste de souhaits' : 'Removed from wishlist',
    reorderAdded: fr ? 'Articles ajoutés à votre panier' : 'Items added to your cart',
    reorderFailed: fr ? "Certains articles n'ont pu être ajoutés" : "Some items couldn't be re-added"
  };
})();

/* ============================================
   DELIVERY ESTIMATOR + TAX CALCULATOR
   ============================================ */
(function () {
  'use strict';

  var STORAGE_POSTAL = 'sbp_postal_code';
  var STORAGE_PROVINCE = 'sbp_province';

  // FSA (first letter of Canadian postal code) → province
  var FSA_PROVINCE = {
    A: 'NL', B: 'NS', C: 'PE', E: 'NB', G: 'QC', H: 'QC', J: 'QC',
    K: 'ON', L: 'ON', M: 'ON', N: 'ON', P: 'ON',
    R: 'MB', S: 'SK', T: 'AB', V: 'BC', X: 'NT', Y: 'YT'
    // X is shared between NT/NU — we treat as NT for tax (both GST-only)
  };

  // Tax rates per province (GST + PST/HST/QST), 2026 reference
  var TAX_RATES = {
    AB: { gst: 0.05, pst: 0,    qst: 0, hst: 0,    label: 'GST 5%' },
    BC: { gst: 0.05, pst: 0.07, qst: 0, hst: 0,    label: 'GST 5% + PST 7%' },
    MB: { gst: 0.05, pst: 0.07, qst: 0, hst: 0,    label: 'GST 5% + RST 7%' },
    NB: { gst: 0,    pst: 0,    qst: 0, hst: 0.15, label: 'HST 15%' },
    NL: { gst: 0,    pst: 0,    qst: 0, hst: 0.15, label: 'HST 15%' },
    NS: { gst: 0,    pst: 0,    qst: 0, hst: 0.14, label: 'HST 14%' },
    NT: { gst: 0.05, pst: 0,    qst: 0, hst: 0,    label: 'GST 5%' },
    NU: { gst: 0.05, pst: 0,    qst: 0, hst: 0,    label: 'GST 5%' },
    ON: { gst: 0,    pst: 0,    qst: 0, hst: 0.13, label: 'HST 13%' },
    PE: { gst: 0,    pst: 0,    qst: 0, hst: 0.15, label: 'HST 15%' },
    QC: { gst: 0.05, pst: 0,    qst: 0.09975, hst: 0, label: 'GST 5% + QST 9.975%' },
    SK: { gst: 0.05, pst: 0.06, qst: 0, hst: 0,    label: 'GST 5% + PST 6%' },
    YT: { gst: 0.05, pst: 0,    qst: 0, hst: 0,    label: 'GST 5%' }
  };

  // Transit days from a warehouse to a province (business days, low-end estimate)
  // Origins: TOR (Toronto), VAN (Vancouver), MTL (Montréal)
  var TRANSIT = {
    TOR: { ON: 1, QC: 2, MB: 3, NB: 3, NS: 4, PE: 4, NL: 5, SK: 4, AB: 4, BC: 5, YT: 7, NT: 7, NU: 9 },
    VAN: { BC: 1, AB: 2, SK: 3, MB: 4, ON: 5, QC: 5, NB: 6, NS: 6, PE: 7, NL: 7, YT: 4, NT: 5, NU: 9 },
    MTL: { QC: 1, ON: 2, NB: 2, NS: 3, PE: 3, NL: 4, MB: 4, SK: 5, AB: 5, BC: 5, YT: 7, NT: 7, NU: 9 }
  };

  // Default reroute time: distributor warehouse → us in Montréal (when not dropship)
  var REROUTE_DAYS = 2;
  // Processing handling buffer (we pack & ship)
  var HANDLING_DAYS = 1;

  function normalizeWarehouse(tag) {
    if (!tag) return null;
    var t = String(tag).toLowerCase().replace(/[\s_-]/g, '');
    if (t.indexOf('toronto') > -1 || t === 'tor' || t === 'on') return 'TOR';
    if (t.indexOf('vancouver') > -1 || t === 'van' || t === 'bc') return 'VAN';
    if (t.indexOf('montreal') > -1 || t === 'mtl' || t === 'qc') return 'MTL';
    return null;
  }

  function postalToProvince(postal) {
    if (!postal) return null;
    var first = String(postal).trim().toUpperCase().charAt(0);
    return FSA_PROVINCE[first] || null;
  }

  function isCanadianPostal(postal) {
    if (!postal) return false;
    return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(postal.trim());
  }

  function addBusinessDays(startDate, days) {
    var d = new Date(startDate.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function formatRange(d1, d2, locale) {
    var opts = { weekday: 'short', month: 'short', day: 'numeric' };
    try {
      var s1 = d1.toLocaleDateString(locale, opts);
      var s2 = d2.toLocaleDateString(locale, opts);
      return s1 + ' – ' + s2;
    } catch (e) {
      return d1.toDateString() + ' – ' + d2.toDateString();
    }
  }

  // Compute ETA for a single product/line
  function computeEta(opts) {
    // opts: { warehouse, isDropship, available, province }
    var prov = opts.province;
    if (!prov) return null;

    var origin = normalizeWarehouse(opts.warehouse);
    var minDays, maxDays, methodKey;

    if (opts.available === false) {
      // Backorder
      minDays = 7; maxDays = 14;
      methodKey = 'backorder';
    } else if (opts.isDropship && origin) {
      // Dropship: ships directly from distributor warehouse to customer
      var dropDays = (TRANSIT[origin] && TRANSIT[origin][prov]) || 5;
      minDays = HANDLING_DAYS + dropDays;
      maxDays = minDays + 1;
      methodKey = 'dropship';
    } else if (origin) {
      // Through us: distributor → Montréal → customer
      var legA = (TRANSIT[origin] && TRANSIT[origin]['QC']) || REROUTE_DAYS;
      var legB = (TRANSIT['MTL'] && TRANSIT['MTL'][prov]) || 3;
      minDays = HANDLING_DAYS + legA + legB;
      maxDays = minDays + 1;
      methodKey = 'reroute';
    } else {
      // No warehouse info → assume in-stock Montréal
      var directDays = (TRANSIT['MTL'] && TRANSIT['MTL'][prov]) || 3;
      minDays = HANDLING_DAYS + directDays;
      maxDays = minDays + 1;
      methodKey = 'direct';
    }

    var now = new Date();
    var minDate = addBusinessDays(now, minDays);
    var maxDate = addBusinessDays(now, maxDays);
    return { minDays: minDays, maxDays: maxDays, minDate: minDate, maxDate: maxDate, method: methodKey };
  }

  function methodLabel(methodKey, lang) {
    var fr = lang === 'fr';
    var map = {
      direct:    fr ? 'Expédié de notre entrepôt de Montréal'         : 'Ships from our Montréal warehouse',
      dropship:  fr ? 'Expédié directement par le distributeur'        : 'Ships direct from distributor',
      reroute:   fr ? 'Transitant par notre entrepôt de Montréal'      : 'Routed through our Montréal warehouse',
      backorder: fr ? 'Sur commande — délai prolongé'                  : 'Backorder — extended lead time'
    };
    return map[methodKey] || '';
  }

  // ---- POSTAL CODE PERSISTENCE ----
  function getStoredPostal() {
    try { return localStorage.getItem(STORAGE_POSTAL) || ''; } catch (e) { return ''; }
  }
  function setStoredPostal(p) {
    try { localStorage.setItem(STORAGE_POSTAL, p); } catch (e) {}
  }
  function getStoredProvince() {
    try { return localStorage.getItem(STORAGE_PROVINCE) || ''; } catch (e) { return ''; }
  }
  function setStoredProvince(p) {
    try { localStorage.setItem(STORAGE_PROVINCE, p); } catch (e) {}
  }

  // ---- PDP DELIVERY ESTIMATOR ----
  function initPdpEstimator() {
    var el = document.querySelector('[data-delivery-estimator]');
    if (!el) return;

    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    var input = el.querySelector('[data-de-postal]');
    var submitBtn = el.querySelector('[data-de-submit]');
    var etaEl = el.querySelector('[data-de-eta]');
    var methodEl = el.querySelector('[data-de-method]');
    var helpEl = el.querySelector('[data-de-help]');

    var stored = getStoredPostal();
    if (stored && input) input.value = stored;

    function update() {
      var raw = (input.value || '').trim().toUpperCase();
      if (!raw) {
        etaEl.textContent = '—';
        methodEl.textContent = '';
        helpEl.textContent = lang === 'fr' ? 'Entrez votre code postal pour estimer la livraison.' : 'Enter your postal code to estimate delivery.';
        helpEl.className = 'de-postal-help';
        return;
      }
      if (!isCanadianPostal(raw)) {
        helpEl.textContent = lang === 'fr' ? 'Code postal canadien invalide.' : 'Invalid Canadian postal code.';
        helpEl.className = 'de-postal-help de-postal-help--error';
        etaEl.textContent = '—';
        methodEl.textContent = '';
        return;
      }
      setStoredPostal(raw);
      var prov = postalToProvince(raw);
      if (prov) setStoredProvince(prov);

      var eta = computeEta({
        warehouse: el.dataset.warehouse,
        isDropship: el.dataset.dropship === '1',
        available: el.dataset.productAvailable === '1',
        province: prov
      });

      if (!eta) {
        etaEl.textContent = '—';
        return;
      }
      etaEl.textContent = formatRange(eta.minDate, eta.maxDate, lang === 'fr' ? 'fr-CA' : 'en-CA');
      methodEl.textContent = methodLabel(eta.method, lang);
      helpEl.textContent = lang === 'fr' ? 'Livraison standard gratuite partout au Canada.' : 'Free standard shipping across Canada.';
      helpEl.className = 'de-postal-help';
    }

    if (submitBtn) submitBtn.addEventListener('click', update);
    if (input) {
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); update(); } });
      input.addEventListener('blur', update);
    }
    if (stored) update();
  }

  // ---- CART: DELIVERY + TAX ESTIMATOR ----
  function initCartEstimator() {
    var de = document.querySelector('[data-delivery-estimator-cart]');
    var provSel = document.querySelector('[data-cart-province]');
    var taxEl = document.querySelector('[data-cart-tax]');
    var taxRow = document.querySelector('[data-cart-tax-row]');
    var taxProvLabel = document.querySelector('[data-cart-tax-province]');
    var totalEl = document.querySelector('[data-cart-total-estimated]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');

    if (!provSel && !de) return;

    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';

    function fmtMoney(cents) {
      try {
        return new Intl.NumberFormat(lang === 'fr' ? 'fr-CA' : 'en-CA', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function recalcTaxes(prov) {
      if (!subtotalEl || !taxEl || !totalEl) return;
      var subtotalCents = parseInt(subtotalEl.dataset.cartSubtotalCents, 10) || 0;
      if (!prov) {
        taxEl.textContent = '—';
        if (taxProvLabel) taxProvLabel.textContent = '';
        totalEl.textContent = fmtMoney(subtotalCents);
        if (taxRow) taxRow.classList.remove('is-active');
        return;
      }
      var rates = TAX_RATES[prov];
      if (!rates) return;
      var rate = rates.gst + rates.pst + rates.qst + rates.hst;
      var taxCents = Math.round(subtotalCents * rate);
      taxEl.textContent = fmtMoney(taxCents);
      if (taxProvLabel) taxProvLabel.textContent = ' (' + rates.label + ')';
      totalEl.textContent = fmtMoney(subtotalCents + taxCents);
      if (taxRow) taxRow.classList.add('is-active');
    }

    function updateCartDelivery(postalOrProv) {
      if (!de) return;
      var etaEl = de.querySelector('[data-de-eta]');
      var helpEl = de.querySelector('[data-de-help]');
      if (!etaEl) return;

      var prov = postalOrProv;
      if (postalOrProv && postalOrProv.length > 2) {
        if (!isCanadianPostal(postalOrProv)) {
          if (helpEl) {
            helpEl.textContent = lang === 'fr' ? 'Code postal invalide.' : 'Invalid postal code.';
            helpEl.className = 'de-postal-help de-postal-help--error';
          }
          etaEl.textContent = '—';
          return;
        }
        prov = postalToProvince(postalOrProv);
      }
      if (!prov) { etaEl.textContent = '—'; return; }
      if (helpEl) {
        helpEl.textContent = lang === 'fr' ? 'Livraison standard gratuite partout au Canada.' : 'Free standard shipping across Canada.';
        helpEl.className = 'de-postal-help';
      }

      // For the cart-level estimate, assume worst-case (Toronto reroute) so the
      // promise is conservative and accurate across mixed-warehouse carts.
      var eta = computeEta({ warehouse: 'toronto', isDropship: false, available: true, province: prov });
      if (!eta) { etaEl.textContent = '—'; return; }
      etaEl.textContent = formatRange(eta.minDate, eta.maxDate, lang === 'fr' ? 'fr-CA' : 'en-CA');
    }

    // Cart postal input handlers
    if (de) {
      var cartInput = de.querySelector('[data-de-postal]');
      var cartBtn = de.querySelector('[data-de-submit]');
      var storedP = getStoredPostal();
      if (storedP && cartInput) cartInput.value = storedP;

      function cartUpdate() {
        var raw = (cartInput.value || '').trim().toUpperCase();
        setStoredPostal(raw);
        var prov = postalToProvince(raw);
        if (prov) {
          setStoredProvince(prov);
          if (provSel) provSel.value = prov;
          recalcTaxes(prov);
        }
        updateCartDelivery(raw);
      }
      if (cartBtn) cartBtn.addEventListener('click', cartUpdate);
      if (cartInput) {
        cartInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); cartUpdate(); } });
        cartInput.addEventListener('blur', cartUpdate);
      }
    }

    // Province selector
    if (provSel) {
      var storedProv = getStoredProvince();
      if (storedProv) provSel.value = storedProv;
      provSel.addEventListener('change', function () {
        var p = provSel.value;
        if (p) {
          setStoredProvince(p);
          recalcTaxes(p);
          updateCartDelivery(p);
        }
      });
      if (provSel.value) {
        recalcTaxes(provSel.value);
        updateCartDelivery(provSel.value);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPdpEstimator();
    initCartEstimator();
  });
})();